import { lazy, JSX } from 'react';
import { LazyComponent } from '@bg-components/LazyComponent';

const Component = lazy(() => import('./HollywoodBetsFooter'));

export const HollywoodBetsFooter = (): JSX.Element => (
    <LazyComponent>
        <Component />
    </LazyComponent>
);
